import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { SharedModule } from '../shared/shared.module';

import { AuditableTextControlDirective } from '../shared/auditable-text-control.directive';
import { ItemInstructionsComponent } from '../shared/item-editor/item-instructions/item-instructions.component';
import { ItemChoicesComponent } from '../shared/item-editor/item-choices/item-choices.component';
import { ChoiceComponent } from '../shared/item-editor/choice/choice.component';
import { ChoiceGroupsComponent } from '../shared/choice-groups/choice-groups.component';
import { IngredientInfoComponent } from '../shared/item-editor/choice/ingredient-info/ingredient-info.component';
import { IngredientComponent } from '../shared/item-editor/choice/ingredient/ingredient.component';
import { IngredientFlatComponent } from '../shared/item-editor/choice/ingredient/ingredient-flat/ingredient-flat.component';
import { IngredientCardComponent } from '../shared/item-editor/choice/ingredient/ingredient-card/ingredient-card.component';
import { IngredientGroupFilterPipe } from '../shared/pipes/ingredient-group-filter.pipe';
import { ItemChoiceComponent } from '../shared/special-wizard-item-selector/item-choice/item-choice.component';
import { PillsChoicesComponent } from '../shared/pills-choices/pills-choices.component';
import { StepControlsComponent } from '../shared/step-controls/step-controls.component';
import { ChoiceGroupFilterPipe } from '../shared/pipes/choice-group-filter.pipe';
import { OrderedChoicePipe } from '../shared/pipes/ordered-choice.pipe';
import { ValidPipe } from '../shared/pipes/valid.pipe';
import { DependencyMetPipe } from '../shared/pipes/dependency-met.pipe';
import { ChoiceIndexPipe } from '../shared/pipes/choice-index.pipe';
import { CanMoveToStepChoicePipe } from '../shared/pipes/can-move-to-step-choice.pipe';
import { ServingsPipe } from '../shared/pipes/servings.pipe';
import { InvalidChoiceGroupPipe } from '../shared/pipes/invalid-choice-group.pipe';
import { GroupIndexPipe } from '../shared/pipes/group-index.pipe';
import { CanMoveToStepGroupPipe } from '../shared/pipes/can-move-to-step-group.pipe';
import { FilterOutInstructionPipe } from '../shared/pipes/filter-out-instruction.pipe';
import { SpecialWizardItemEditorComponent } from '../shared/special-wizard-item-editor/special-wizard-item-editor.component';
import { SpecialWizardItemSelectorEntryComponent } from '../shared/special-wizard-item-selector-entry/special-wizard-item-selector-entry.component';
import { SpecialWizardItemSelectorComponent } from '../shared/special-wizard-item-selector/special-wizard-item-selector.component';
import { SpecialWizardModalContentComponent } from '../shared/special-wizard-modal-content/special-wizard-modal-content.component';
import { SpecialWizardModalFooterComponent } from '../shared/special-wizard-modal-footer/special-wizard-modal-footer.component';
import { SpecialWizardModalComponent } from '../shared/special-wizard-modal/special-wizard-modal.component';
import { SisterUpsellsComponent } from '../shared/sister-upsells/sister-upsells.component';
import { SisterUpsellComponent } from '../shared/sister-upsells/sister-upsell/sister-upsell.component';
import { OrderTreeModule } from 'app/shared/order-tree/order-tree.module';
import { NgbPopoverModule } from '@ng-bootstrap/ng-bootstrap';
import { DeactivatedDirective } from '../menu/deactivated.directive';
import { SortByLineNumberPipe } from 'app/shared/sort-by-line-number.pipe';
import { EditorComponent } from './editor/editor.component';
import { PizzaBuilderComponent } from './pizza-builder/pizza-builder.component';
import { ItemEditorControlsComponent } from './item-editor-controls/item-editor-controls.component';
import { PrintIngredientsComponent } from './print-ingredients/print-ingredients.component';
import { ItemEditorModalComponent } from 'app/shared/item-editor-modal/item-editor-modal.component';
import { ItemEditorModalFooterComponent } from 'app/shared/item-editor-modal-footer/item-editor-modal-footer.component';
import { ItemEditorModalHeaderComponent } from 'app/shared/item-editor-modal-header/item-editor-modal-header.component';
import { CanLeaveEditorGuard } from './editor/can-leave-editor.guard';
import { OrderableEditorComponent } from './orderable-editor/orderable-editor.component';
import { OrderedEditorComponent } from './ordered-editor/ordered-editor.component';
import { RouterModule } from '@angular/router';
import { ItemEditorGuard } from './item-editor.guard';
import { SecialtyHalfComponent } from './specialty-half/specialty-half.component';
@NgModule({
  declarations: [
    AuditableTextControlDirective,
    ItemInstructionsComponent,
    ItemChoicesComponent,
    ChoiceComponent,
    ChoiceGroupsComponent,
    IngredientComponent,
    IngredientInfoComponent,
    IngredientFlatComponent,
    IngredientCardComponent,
    IngredientGroupFilterPipe,
    ItemChoiceComponent,
    PillsChoicesComponent,
    StepControlsComponent,
    ChoiceGroupFilterPipe,
    OrderedChoicePipe,
    ValidPipe,
    DependencyMetPipe,
    ChoiceIndexPipe,
    CanMoveToStepChoicePipe,
    ServingsPipe,
    InvalidChoiceGroupPipe,
    GroupIndexPipe,
    CanMoveToStepGroupPipe,
    FilterOutInstructionPipe,
    SpecialWizardItemEditorComponent,
    SpecialWizardItemSelectorEntryComponent,
    SpecialWizardItemSelectorComponent,
    SpecialWizardModalContentComponent,
    SpecialWizardModalFooterComponent,
    SpecialWizardModalComponent,
    SisterUpsellsComponent,
    SisterUpsellComponent,
    DeactivatedDirective,
    SortByLineNumberPipe,
    ItemEditorModalComponent,
    ItemEditorModalFooterComponent,
    ItemEditorModalHeaderComponent,
    EditorComponent,
    PizzaBuilderComponent,
    ItemEditorControlsComponent,
    PrintIngredientsComponent,
    OrderableEditorComponent,
    OrderedEditorComponent,
    SecialtyHalfComponent,
  ],
  imports: [
    CommonModule,
    TranslateModule,
    FontAwesomeModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    OrderTreeModule,
    NgbPopoverModule,
    RouterModule,
  ],
  providers: [CanLeaveEditorGuard, ItemEditorGuard],
  exports: [
    ItemChoicesComponent,
    ChoiceComponent,
    ChoiceGroupsComponent,
    IngredientComponent,
    IngredientInfoComponent,
    ItemChoiceComponent,
    SpecialWizardItemEditorComponent,
    SpecialWizardItemSelectorEntryComponent,
    SpecialWizardItemSelectorComponent,
    SpecialWizardModalContentComponent,
    SpecialWizardModalFooterComponent,
    SpecialWizardModalComponent,
    SisterUpsellsComponent,
    SisterUpsellComponent,
    ServingsPipe,
    DeactivatedDirective,
    SortByLineNumberPipe,
    ItemEditorModalComponent,
    ItemEditorModalFooterComponent,
    EditorComponent,
    PizzaBuilderComponent,
    ItemEditorControlsComponent,
    PrintIngredientsComponent,
    OrderableEditorComponent,
    OrderedEditorComponent,
    SecialtyHalfComponent,
  ],
})
export class EditorSharedModule {}
